import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core'
import { ContainerModel, EventCardModel } from '@flocasts/experience-service-types'
import { breakpointsInPixels } from 'src/app/app.config'
import { isEventCardModel } from 'src/app/shared/functions/type-guards'
import { CheckoutNavigationService } from 'src/app/shared/services/checkout-navigation.service'
import SwiperCore, { SwiperOptions, Mousewheel, FreeMode } from 'swiper'

SwiperCore.use([Mousewheel, FreeMode])

@Component({
  selector: 'flo-event-card-scroll',
  templateUrl: './event-card-scroll.component.html',
  styleUrls: ['./event-card-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventCardScrollComponent implements OnChanges {
  @Input() eventCardContainer: ContainerModel
  @Input() geoBlockedIds: ReadonlyArray<number> = []
  public isEventListExpanded = false
  public thumbnailEventCardItems: EventCardModel[]
  public moreUpcomingEventItems: EventCardModel[] | null = null

  config: SwiperOptions = {
    freeMode: {
      enabled: true,
      sticky: true
    },
    slidesPerView: 'auto',
    spaceBetween: 8,
    mousewheel: true,
    centeredSlides: false,
    centeredSlidesBounds: false,
    centerInsufficientSlides: true,
    slidesOffsetBefore: 30,

    breakpoints: {
      [breakpointsInPixels.medium]: {
        centeredSlides: false,
        centerInsufficientSlides: false,
        slidesOffsetBefore: 0
      }
    }
  }

  constructor(private checkoutNavService: CheckoutNavigationService) {}

  ngOnChanges(): void {
    if (!!this.eventCardContainer) {
      this.thumbnailEventCardItems = this.getThumbnailEventCardItems(this.eventCardContainer)
      this.moreUpcomingEventItems = this.getMoreUpcomingEventItems(this.eventCardContainer)
    }
  }

  // populate thumbnail event card with the first 10 items
  private getThumbnailEventCardItems(container: ContainerModel) {
    const firstTenItems = container?.items.slice(0, 10)
    // type guard to check if the items are EventCardModel[]
    return firstTenItems.every(isEventCardModel) ? firstTenItems : []
  }

  // populate upcoming event card with the remaining items
  private getMoreUpcomingEventItems(container: ContainerModel) {
    if (container.items.length > 10) {
      const remainingItems = container?.items.slice(10)
      // type guard to check if the items are EventCardModel[]
      return remainingItems.every(isEventCardModel) ? remainingItems : null
    }
    return null
  }

  getFirstWord(text: string): string {
    const words = text?.split(' ')
    return words && words.length > 0 ? words[0] : ''
  }

  getSecondWord(text: string): string | null {
    const words = text?.split(' ')
    return words && words.length > 1 ? words[1] : null
  }

  getRemainingWords(text: string): string | null {
    const words = text?.split(' ')
    if (words && words.length > 2) {
      return words.slice(2).join(' ')
    }
    return null
  }

  handleEventItemClicked(eventCard: EventCardModel) {
    let liveEventRedirect
    if (eventCard.action.analytics?.extraContext?.eventStatus && eventCard.action.analytics?.entityId) {
      liveEventRedirect = {
        status: eventCard.action.analytics.extraContext.eventStatus,
        eventId: eventCard.action.analytics?.entityId
      }
    }
    const redirect = eventCard.cta1?.url ?? eventCard.action.url
    this.checkoutNavService.navigateAfterLandingPage({ redirect }, false, liveEventRedirect)
  }
}
